import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';

// Hardcoded admin whitelist - emails that have access to analytics dashboard
const ADMIN_WHITELIST = [
  'fishimwe@amazon.com',
  'pmalmont@amazon.com'
];

export const useAdminAuth = () => {
  const { user, email } = useAuth();
  
  const isAdmin = useMemo(() => {
    if (!user || !email) {
      return false;
    }
    
    return ADMIN_WHITELIST.includes(email.toLowerCase());
  }, [user, email]);
  
  return {
    isAdmin,
    user,
    email,
    adminEmails: ADMIN_WHITELIST // For debugging purposes
  };
};
